<template>
  <a-modal
    title="图形验证"
    :visible="graphCertificateModalVisible"
    :keyboard="false"
    :maskClosable="false"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
    class="graphCertificate-wrap"
    width="600px"
  >
    <div class="graphInfo-containter">
      <span class="required">验证码：</span>
      <a-input
        style="width:200px; margin: 0 10px;"
        placeholder="请输入右侧计算结果"
        v-model="graphCode"
      />
      <div class="img-wrap">
        <img :src="graphSrc" alt="" @click="getGraphSrc">
      </div>
    </div>
  </a-modal>
</template>
<script>
import axios from 'axios'

export default {
  name: 'GraphCertificateModalVisible',
  props: {
    graphCertificateModalVisible: {
      type: Boolean,
      default: true
    },
    // java写的userCenter的接口地址
    securityUserCenterUrl: {
      type: String,
      default () {
        return 'http://47.106.143.201:9001/security/userCenter'
      }
    }
  },
  watch: {
    graphCertificateModalVisible: {
      handler (val) {
        if (!val) {
          this.graphCode = null
          this.phoneNumber = null
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      graphCode: null,
      graphSrc: null,
      phoneNumber: null
    }
  },
  methods: {
    // 提供给父组件进行调用
    setPhoneNumber (phoneNumber) {
      this.phoneNumber = phoneNumber
      // 根据手机号码获取图形验证
      this.getGraphSrc()
    },
    // 获取图形地址
    getGraphSrc () {
      if (!this.phoneNumber) {
        this.$message.error('请按要求填写手机号码')
        return
      }
      axios({
        url: `${this.securityUserCenterUrl}/api/services/app/Account/LineCaptcha?phoneNumber=${this.phoneNumber}`,
        method: 'get'
      }).then(res => {
        if (res.status === 200) {
          this.graphSrc = res.data.result
        } else {
          this.$message.error('获取图形验证图片失败')
        }
      })
    },
    ok () {
      if (!this.graphCode) {
        this.$message.error('请输入右侧计算结果')
        return
      }
      this.$emit('ok', this.graphCode)
    },
    cancel () {
      this.$emit('cancel', this.graphCode)
    }
  }
}
</script>
<style lang="less">
.graphCertificate-wrap {
  width: 400px;
  .graphInfo-containter {
    display:flex;
    align-items:center;
    justify-content: center;
    .required {
      &::before {
        content: '*';
        color: red;
        margin-right: 5px;
        font-size: 12px;
      }
    }
    .img-wrap {
      display: inline-block;
      img {
        cursor: pointer;
        width: 200px;
        height: 45px;
      }
    }
  }
}
</style>
